import { FC, useCallback } from "react"
import { useNavigate } from "react-router"
import AuthLayout from "@/components/AuthLayout"
import LoginSupport from "@/components/LoginSupport"
import Button from "@/components/shared/Button"
import { PageRoutes } from "@/constants/routes"

const InstructionsSent: FC = () => {
   const navigate = useNavigate()

   const handleNavigate = useCallback(() => {
      navigate(PageRoutes.LOGIN)
   }, [navigate])

   return (
      <AuthLayout
         iconName="mail"
         title="Instructions sent"
         instructions={
            <>
               <div className="password-recovery__instructions-description">
                  If your account is known to us, a recovery email has been
                  sent. Please check your email inbox for further instructions.
               </div>
               <LoginSupport />
            </>
         }
      >
         <>
            <span className="password-recovery__form-text password-recovery__form-text--margin">
               Recovery instructions sent.
            </span>
            <div className="password-recovery__form-button-wrapper">
               <Button onClick={handleNavigate}>Back to login screen</Button>
            </div>
            <div className="password-recovery__form-text password-recovery__form-text--margin">
               Forgotten your email address? <br /> Please contact your local
               administrator.
            </div>
         </>
      </AuthLayout>
   )
}

export default InstructionsSent
